import { toImportExcel } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('usersGroups');

import { queryAddUserGroupUser, queryEditActive, queryUserGroupUsers } from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'usersGroups',

  state: {
    newUserGroup: false,
    newUserOnGroup: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    listUserGroupUser: [],
    pagination: meta,
    select: 'id,name,isActive,description',
    paramsView: {
      select: 'id,name,isActive,description,created,updated,',
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select: 'id,name,isActive,description',
    },
    view: false,
    orderBy: '',
    id: null,
    showImport: false,
  },

  effects: {
    *fetchData({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'userGroup/paged',
          params: payload,
          ...(payload.readPriority && { readPriority: true }),
        });
        yield put({
          type: 'queryUsersGroups',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewUserOnGroup({ payload }, { put }) {
      yield put({
        type: 'addUserOnGroup',
        payload,
      });
    },
    *fetchUserOnGroup({ payload }, { call, put }) {
      try {
        const response = yield call(queryUserGroupUsers, payload);
        yield put({
          type: 'listUserOnGroup',
          response,
        });
      } catch (error) {
        /*  */
      }
    },
    *hideNewUserOnGroup({ payload = 'hideUserOnGroup' }, { put }) {
      yield put({
        type: payload,
      });
    },
    *onCloseUserOnGroup(_a, { put }) {
      yield put({
        type: 'closeUserOnGroup',
      });
    },
    *addUserGroupUser({ payload }, { put }) {
      yield put({
        type: 'addUserGroupList',
        payload,
      });
    },
    *saveUserGroupUsers({ payload }, { call, put }) {
      try {
        yield call(queryAddUserGroupUser, payload);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'addUserOnGroup',
          payload: {
            state: false,
            item: null,
            form: null,
          },
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: false,
              visibleForm: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
    *addNewUserGroup({ payload }, { put }) {
      yield put({
        type: 'addUserGroup',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewUserGroup',
          payload,
        });
      }
    },
    *editItemUserGroup({ payload }, { call, put }) {
      try {
        yield put({
          type: 'global/loadingItem',
          payload: true,
        });
        const table = yield call(api.getById, {
          route: 'userGroup',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editUserGroup',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
        yield put({
          type: 'global/loadingItem',
          payload: false,
        });
      } catch (error) {
        yield put({
          type: 'global/loadingItem',
          payload: false,
        });
      }
    },
    *saveNewUserGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'userGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveUserGroup',
          payload: response,
        });
        yield put({
          type: 'fetchData',
          payload: {
            ...params,
            readPriority: true,
          },
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveEditUserGroup({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'userGroup',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveUserGroup',
          payload: response,
        });

        yield put({
          type: 'fetchData',
          payload: {
            ...params,
            readPriority: true,
          },
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `userGroup/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'saveUserGroup',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchData',
          payload: params,
        });
      } catch (error) {
        // TODO: No message comes inside the error
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotificationsGlobal`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *deleteItemUserGroup({ id }, { put }) {
      try {
        yield put({
          type: 'deleteUserGroupUser',
          payload: id,
        });
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
      } catch (error) {
        yield put({
          type: `global/showNotificationsGlobal`,
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
            autoHide: view,
          },
        });
      }
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },
    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *eventSorterUserGroup({ payload }, { put }) {
      yield put({
        type: 'sorterUserGroup',
        payload,
      });
    },
    *fetchImport({ payload }, { call, put, select }) {
      try {
        const { file, isDeleteData } = payload;
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(toImportExcel, {
          route: 'userGroup',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        yield put({
          type: 'queryImport',
          payload: { ...res },
        });

        yield put({
          type: 'fetchData',
          payload: {
            page: 1,
            limit: pageSize,
            readPriority: true,
          },
        });
      } catch (e) {
        /*  */
      }
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },
  },

  reducers: {
    queryUsersGroups(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addUserGroup(state, { payload }) {
      return {
        ...state,
        newUserGroup: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },
    editUserGroup(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },
    editOrViewUserGroup(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    addUserOnGroup(state, { payload }) {
      return {
        ...state,
        newUserOnGroup: payload.state,
        selectedItem: payload.item,
        formConfig: payload.form,
      };
    },
    sorterUserGroup(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideUserOnGroup(state) {
      return {
        ...state,
        selectedItem: null,
        listUserGroupUser: [],
        formConfig: null,
      };
    },
    closeUserOnGroup(state) {
      return {
        ...state,
        newUserOnGroup: false,
      };
    },
    listUserOnGroup(state, { response }) {
      return {
        ...state,
        listUserGroupUser: response.map((item) => {
          return {
            id: item.id,
            user: item.fullName,
          };
        }),
      };
    },
    addUserGroupList(state, { payload }) {
      return {
        ...state,
        listUserGroupUser: [...state.listUserGroupUser, payload],
      };
    },
    saveUserGroup(state, { payload }) {
      return {
        ...state,
        saveUser: payload,
        newUserGroup: false,
        selectedItem: null,
        view: false,
      };
    },
    deleteUserGroupUser(state, { payload }) {
      return {
        ...state,
        listUserGroupUser: state.listUserGroupUser.filter((item) => item.id !== payload),
      };
    },
    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },
    showEditItemUser(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        newUserGroup: false,
        newUserOnGroup: false,
        selectedItem: null,
        id: null,
        orderBy: '',
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
